var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg403(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 516,
    height: 426,
    viewBox: "0 0 516 426",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "darken"
    },
    opacity: 0.37,
    d: "M64.9908 330.381H13.5622C-0.204065 316.079 -3.88038 293.292 4.33141 275.223C12.1736 257.993 28.9968 246.619 39.1866 230.678C60.9449 196.698 50.4354 145.968 79.9958 118.464C94.7711 104.721 116.02 100.744 136.14 99.1347C156.26 97.5257 177.039 97.5756 195.64 89.7502C218.617 80.1057 235.88 59.3878 259.507 51.5823C286.04 42.8174 317.778 53.751 333.283 77.0076C342.983 91.5591 346.65 109.839 358.118 123.041C376.669 144.378 409.357 146.028 432.494 162.288C440.416 167.927 447.061 175.173 451.994 183.555C456.928 191.936 460.039 201.264 461.125 210.93C463.593 234.216 454.751 260.671 468.718 279.48C475.521 288.645 486.56 293.812 493.892 302.567C501.225 311.322 503.263 319.237 500.965 330.381H64.9908Z",
    fill: "#9FEBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1363 330.381H26.6977C12.9414 316.079 9.25512 293.292 17.4769 275.223C25.3191 257.993 42.1423 246.619 52.3321 230.678C74.0904 196.698 63.5709 145.968 93.1313 118.464C107.917 104.721 129.165 100.744 149.275 99.1347C169.385 97.5257 190.234 97.5756 208.786 89.7502C231.763 80.1057 249.016 59.3878 272.652 51.5823C299.186 42.8174 330.924 53.751 346.428 77.0076C356.129 91.5591 359.785 109.839 371.264 123.041C389.815 144.378 422.502 146.028 445.639 162.288C453.56 167.928 460.204 175.175 465.137 183.556C470.071 191.937 473.183 201.265 474.271 210.93C476.738 234.216 467.897 260.671 481.853 279.48C488.666 288.645 499.705 293.812 507.038 302.567C514.371 311.322 516.399 319.237 514.101 330.381H78.1363Z",
    fill: "#DDECFF",
    style: {
      mixBlendMode: "darken"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.51 154.192L194.392 154.262H3.12345L2.66392 154.322C0.765812 141.629 10.6559 128.737 23.1934 125.339C34.1225 122.34 46.9097 125.009 56.0606 118.343C64.2624 112.346 66.3003 101.163 71.665 92.5377C75.0243 87.145 79.7313 82.7219 85.3213 79.7051C92.3144 75.9573 100.996 74.6481 108.149 78.0361C120.816 84.0326 123.243 100.843 131.715 112.016C133.603 114.515 135.981 116.844 139.008 117.673C141.795 118.443 144.752 117.843 147.609 117.333C156.97 115.684 168.199 115.834 174.023 123.33C176.76 126.868 177.739 131.405 179.258 135.603C180.776 139.8 183.254 144.128 187.469 145.597C189.467 146.307 191.775 146.326 193.553 147.516C195.701 148.975 196.38 151.523 196.51 154.192Z",
    fill: "url(#paint0_linear_2345_36774)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M504.162 178.358H281.115C280.25 177.089 279.729 175.617 279.601 174.087C279.473 172.556 279.743 171.019 280.385 169.623C282.034 165.975 285.47 163.497 288.897 161.438C292.323 159.379 295.97 157.44 298.537 154.442C303.462 148.556 303.173 140.11 304.261 132.515C305.54 123.52 309.316 114.525 316.13 108.529C318.864 106.156 321.93 104.197 325.23 102.712C334.571 98.3647 346.14 97.2753 354.871 102.712C363.222 107.949 367.318 117.913 374.601 124.559C376.263 126.229 378.328 127.441 380.595 128.077C387.119 129.577 392.663 123.66 397.578 119.083C404.571 112.596 413.822 107.749 423.253 108.959C434.341 110.398 442.913 119.952 447.119 130.276C448.877 134.594 450.216 139.371 453.712 142.439C462.703 150.305 477.828 141.49 488.288 147.206C492.214 149.355 494.841 153.263 496.939 157.201C500.429 163.836 502.866 170.974 504.162 178.358Z",
    fill: "url(#paint1_linear_2345_36774)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.52 256.443H173.794L158.739 146.037C158.739 146.037 136.95 122.231 111.945 117.773L135.762 115.185L189.438 116.644L197.52 256.443Z",
    fill: "#9FEBFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.862 195.738C103.862 195.738 90.3756 215.477 96.3696 232.437L121.455 195.738L118.198 191.361L103.862 195.738Z",
    fill: "#111023"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.793 256.443L172.984 261.54C172.984 261.54 165.831 262.54 165.432 272.754H184.033L194.133 262.89L195.072 256.443H173.793Z",
    fill: "#111023"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.083 145.937L115.343 144.828L120.178 190.391L100.018 197.617L88.3995 141.35C87.6054 138.892 87.3684 136.289 87.7056 133.728C88.0429 131.168 88.9461 128.714 90.3495 126.547C91.7529 124.379 93.6213 122.551 95.819 121.196C98.0167 119.841 100.489 118.993 103.055 118.713L111.916 117.713C136.931 122.211 158.739 146.037 158.739 146.037L145.083 145.937Z",
    fill: "#9FEBFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.316 18.7609V20.1101L88.7076 20.32C88.4079 19.576 87.9669 18.8972 87.4089 18.3212C85.2611 16.4722 83.7626 15.0031 82.2241 15.9026C81.0653 16.5722 81.1552 19.7603 81.2251 21.2595L76.8395 21.8191L37.9883 26.7463V26.6763C40.5058 26.0867 42.4638 21.5593 42.4638 16.0625C42.4638 10.5657 40.5657 6.16822 38.0982 5.46863L90.306 11.3552V18.7809L90.316 18.7609Z",
    fill: "url(#paint2_linear_2345_36774)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9069 8.29697C40.7976 8.45426 40.6975 8.61777 40.6072 8.78669C40.1764 9.92733 39.6725 11.039 39.0987 12.1148C38.5882 12.8529 37.8677 13.4204 37.0307 13.7438C36.1365 14.0313 35.2106 14.2092 34.2735 14.2735C33.6443 14.333 33.0278 14.488 32.4453 14.7332C32.735 9.54625 34.783 5.50859 37.3005 5.37866L38.1097 5.46861C38.7447 5.72328 39.3206 6.10574 39.8018 6.59227C40.2829 7.0788 40.6591 7.65902 40.9069 8.29697Z",
    fill: "url(#paint3_linear_2345_36774)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4548 15.173C41.8154 16.0325 41.5057 17.1019 40.9063 17.9814C40.2021 19.0567 39.1109 19.8191 37.8593 20.1102C36.7405 20.36 35.5217 20.2201 34.4927 20.7398C33.9765 21.015 33.5423 21.4219 33.234 21.9191C32.6704 20.0117 32.391 18.0315 32.4048 16.0425C32.4048 15.5928 32.4048 15.1531 32.4547 14.7133C33.0373 14.4681 33.6537 14.3131 34.2829 14.2536C35.22 14.1893 36.1459 14.0114 37.0402 13.7239C37.8708 13.4042 38.5873 12.8439 39.0981 12.1148C39.6711 11.0455 40.175 9.94057 40.6066 8.80673C40.6969 8.63781 40.797 8.4743 40.9063 8.31702C41.8898 10.471 42.417 12.8053 42.4548 15.173Z",
    fill: "url(#paint4_linear_2345_36774)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4754 16.0427C42.4754 21.5395 40.4774 26.0369 37.9998 26.6565C37.814 26.705 37.6225 26.7285 37.4304 26.7265C35.6722 26.7265 34.1237 24.8176 33.2246 21.9193C33.5329 21.422 33.9672 21.0151 34.4833 20.7399C35.4823 20.2202 36.7311 20.3602 37.85 20.1103C39.0752 19.82 40.1456 19.0776 40.847 18.0315C41.4464 17.152 41.7561 16.0327 42.3954 15.2231C42.4654 15.453 42.4754 15.7428 42.4754 16.0427Z",
    fill: "url(#paint5_linear_2345_36774)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.086 13.4246H136.76C135.44 13.8921 134.202 14.5668 133.094 15.4234C132.594 15.8831 132.814 16.7127 133.424 17.792H121.086V13.4246Z",
    fill: "#111023"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M155.902 16.113V17.852H147.39C146.737 16.4179 146.19 14.9382 145.752 13.4246H155.902V16.113Z",
    fill: "#111023"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.086 17.8016V18.7711H90.3164V12.3948H121.086V13.4342V17.8016Z",
    fill: "#26AE65"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5352 29.6446L84.8119 34.8016C84.8119 34.8016 76.5901 26.1766 76.9198 21.8092L81.3054 21.2495C81.2055 19.7504 81.1156 16.5622 82.3044 15.8926C83.8429 14.9931 85.3014 16.4623 87.4892 18.3112C88.0472 18.8873 88.4882 19.5661 88.7879 20.31C89.9814 23.3329 90.9008 26.457 91.5352 29.6446Z",
    fill: "url(#paint6_linear_2345_36774)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9597 5.48895C45.5001 4.48953 44.0416 5.33904 44.4911 6.31848C45.8615 9.26101 46.4948 12.4932 46.3364 15.7355C46.178 18.9779 45.2326 22.1328 43.582 24.9277C43.4977 25.1188 43.4868 25.3343 43.5513 25.533C43.6158 25.7317 43.7512 25.8997 43.9317 26.0048C44.1121 26.1099 44.325 26.1448 44.5296 26.1028C44.7341 26.0608 44.916 25.9449 45.0406 25.7772C46.8258 22.7232 47.8423 19.2808 48.0024 15.7465C48.1625 12.2122 47.4615 8.692 45.9597 5.48895Z",
    fill: "#111023"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M166.592 36.4608V41.6878L160.338 35.7712L166.592 36.4608Z",
    fill: "url(#paint7_linear_2345_36774)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M166.59 41.6779L172.894 47.6744L178.888 53.3512C178.888 53.3512 192.704 43.6568 197.998 43.5768C198.363 43.5675 198.728 43.5943 199.087 43.6568C203.803 44.3164 206.68 49.7732 205.861 55.0002C204.962 60.6269 205.121 66.8633 199.707 67.8727C194.292 68.8821 170.396 74.6888 170.396 74.6888L144.242 39.1994L147.329 37.1006L154.192 32.2934L155.581 31.2939L158.578 34.1423L160.326 35.7913L166.59 41.6779Z",
    fill: "url(#paint8_linear_2345_36774)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M183.474 37.54L199.088 43.6565C198.729 43.594 198.364 43.5672 197.999 43.5765C192.665 43.6565 178.898 53.3009 178.898 53.3009L172.904 47.6242L183.474 37.54Z",
    fill: "url(#paint9_linear_2345_36774)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M199.699 67.8726L190.628 92.5783L189.409 116.644C189.409 116.644 188.35 116.834 186.502 117.094C177.85 118.323 151.936 121.282 135.733 115.185L142.046 85.2925L139.129 61.7162L103.914 65.6139L81.8164 37.1005L84.8134 34.8018L91.5866 29.6448L112.426 50.0929L145.113 35.8012C145.806 36.3085 146.55 36.7438 147.331 37.1005L144.244 39.2492L170.398 74.7386C170.398 74.7386 194.284 68.892 199.699 67.8726Z",
    fill: "url(#paint10_linear_2345_36774)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M154.194 32.243L147.331 37.1002C146.551 36.7499 145.807 36.3213 145.113 35.8209C144.152 35.2141 143.332 34.4073 142.71 33.4554C142.087 32.5035 141.677 31.4287 141.507 30.3041C141.217 26.8461 135.373 21.2094 133.465 17.8513C132.856 16.772 132.636 15.9424 133.135 15.4827C134.244 14.6261 135.481 13.9514 136.802 13.4839C140.428 12.0447 145.263 11.0653 145.703 13.304C145.715 13.3651 145.731 13.4253 145.753 13.4839C146.193 14.9805 146.74 16.4435 147.391 17.8613C149.879 23.598 154.194 32.243 154.194 32.243Z",
    fill: "#FFB27D"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.38,
    d: "M190.636 92.578C150.626 84.0729 144.242 39.199 144.242 39.199L170.396 74.7084L199.697 67.8723L190.636 92.578Z",
    fill: "url(#paint11_linear_2345_36774)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M183.244 15.7231C183.464 15.6382 183.7 15.6059 183.933 15.6285C184.167 15.6511 184.393 15.7281 184.592 15.8533C184.791 15.9786 184.958 16.1486 185.079 16.3498C185.201 16.551 185.274 16.7779 185.292 17.0123C186.081 20.1105 182.615 23.8184 182.615 23.8184L183.474 37.5404L172.895 47.6246L177.031 35.7714L166.591 36.451L160.347 35.7714L158.599 34.1024C158.599 34.1024 157.38 22.739 157.38 16.1128C157.348 14.8858 157.425 13.6584 157.61 12.445L157.66 12.1152C164.973 13.3544 175.122 10.4961 175.122 10.4961C175.122 10.4961 176.551 24.3581 178.489 24.5979C180.427 24.8378 181.046 17.0623 181.046 17.0623C181.684 16.4756 182.431 16.0205 183.244 15.7231Z",
    fill: "#FFB27D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M183.334 5.64862L183.244 15.7228C182.434 16.0053 181.687 16.4432 181.046 17.012C181.046 17.012 180.436 24.7875 178.488 24.5477C176.54 24.3078 175.122 10.4458 175.122 10.4458C175.122 10.4458 164.972 13.3042 157.659 12.1149C155.552 11.8925 153.575 10.991 152.025 9.54636C146.43 3.64978 148.368 0.301723 156.39 2.13066C164.412 3.9596 181.026 -5.76476 183.334 5.64862Z",
    fill: "#111023"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M177.029 35.7712L172.884 47.6344L166.59 41.6878V36.4608L177.029 35.7712Z",
    fill: "#ED975D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M441.864 364.39C458.604 364.39 472.174 360.529 472.174 355.765C472.174 351.002 458.604 347.14 441.864 347.14C425.125 347.14 411.555 351.002 411.555 355.765C411.555 360.529 425.125 364.39 441.864 364.39Z",
    fill: "#D7E9FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M119.177 369.778C133.809 369.778 145.671 366.842 145.671 363.221C145.671 359.601 133.809 356.665 119.177 356.665C104.545 356.665 92.6836 359.601 92.6836 363.221C92.6836 366.842 104.545 369.778 119.177 369.778Z",
    fill: "#D7E9FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M271.025 394.573C287.644 394.573 301.115 391.978 301.115 388.777C301.115 385.575 287.644 382.98 271.025 382.98C254.407 382.98 240.936 385.575 240.936 388.777C240.936 391.978 254.407 394.573 271.025 394.573Z",
    fill: "#E9FDFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M328.757 155.902L328.508 156.102L302.404 176.42L286.11 189.113L272.544 226.661L268.777 225.312L282.753 186.654L326.31 152.744L328.757 155.902Z",
    fill: "#2A2A2A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M341.264 240.193C338.267 243.721 334.271 246.19 330.275 248.488L330.005 248.018C331.573 246.02 333.232 243.651 332.762 241.142C332.286 239.462 331.276 237.981 329.885 236.925C327.697 234.996 325.26 233.367 323.172 231.338C320.966 229.399 319.486 226.766 318.976 223.872C318.536 220.075 320.584 216.487 321.384 212.749C321.789 211.264 321.73 209.691 321.214 208.242C319.875 205.063 315.829 204.334 312.622 203.055C309.755 201.895 307.058 199.746 306.259 196.758C305.1 192.421 308.187 187.983 307.767 183.516C307.582 181.962 306.987 180.486 306.042 179.238C305.098 177.991 303.838 177.018 302.393 176.42L328.497 156.092C332.922 159.93 336.738 165.017 336.788 170.823C336.788 174.501 335.32 177.999 334.261 181.517C333.753 182.906 333.575 184.395 333.741 185.865C334.151 188.083 335.919 189.762 337.547 191.331C340.914 194.559 344.301 198.487 344.241 203.154C344.181 208.391 339.715 213.059 340.495 218.236C340.994 221.544 343.542 224.182 344.56 227.36C345.969 231.758 344.231 236.665 341.264 240.193Z",
    fill: "#6366F1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M187.839 294.96H168.059V329H134.249V294.96H64.0995V270.81L136.089 164.78H168.059V268.05H187.839V294.96ZM134.249 240.22C134.249 237.613 134.249 234.547 134.249 231.02C134.403 227.34 134.556 223.737 134.709 220.21C134.863 216.53 135.016 213.31 135.169 210.55C135.323 207.637 135.476 205.643 135.629 204.57H134.709C133.329 207.637 131.873 210.627 130.339 213.54C128.806 216.453 126.966 219.443 124.819 222.51L94.6895 268.05H134.249V240.22Z",
    fill: "#1E293B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M328.999 278.678C325.991 291.517 322.254 302.768 317.785 312.43C313.467 322.127 308.229 330.034 302.071 336.151C296.098 342.154 289.091 346.182 281.051 348.236C273.16 350.324 264.064 350.162 253.763 347.749C240.924 344.742 231.168 338.992 224.496 330.5C217.823 322.007 213.905 311.168 212.742 297.982C211.728 284.831 213.232 269.671 217.254 252.502C221.31 235.184 226.564 220.824 233.014 209.421C239.465 198.019 247.565 189.995 257.315 185.349C267.065 180.704 278.732 179.972 292.318 183.155C305.157 186.162 314.913 191.912 321.585 200.404C328.293 208.747 332.21 219.586 333.339 232.922C334.502 246.108 333.055 261.36 328.999 278.678ZM250.844 260.371C248.012 272.463 246.305 282.773 245.726 291.298C245.181 299.675 245.987 306.32 248.142 311.235C250.483 316.035 254.489 319.1 260.162 320.429C265.836 321.758 270.712 320.774 274.791 317.477C279.02 314.216 282.75 308.711 285.982 300.964C289.398 293.103 292.54 283.051 295.408 270.809C298.276 258.567 299.907 248.241 300.303 239.829C300.882 231.303 300.002 224.64 297.662 219.84C295.506 214.926 291.592 211.804 285.918 210.475C280.245 209.146 275.277 210.187 271.013 213.598C266.934 216.894 263.261 222.491 259.994 230.387C256.762 238.134 253.712 248.129 250.844 260.371Z",
    fill: "#1E293B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M449.19 194.07C451.203 201.308 451.399 208.018 449.776 214.199C448.3 220.339 445.45 225.827 441.225 230.663C437.147 235.457 432.084 239.571 426.036 243.004L426.221 243.669C439.336 241.612 450.007 242.783 458.233 247.179C466.606 251.535 472.251 258.957 475.169 269.445C477.716 278.604 477.727 287.514 475.202 296.174C472.784 304.645 467.443 312.337 459.18 319.251C451.024 325.976 439.56 331.393 424.787 335.502C416.071 337.926 407.741 339.447 399.796 340.065C391.851 340.684 384.165 340.514 376.736 339.556L368.847 311.193C376.588 312.701 384.398 313.313 392.277 313.032C400.304 312.709 407.494 311.664 413.846 309.897C425.812 306.569 433.583 302.179 437.16 296.728C440.884 291.236 441.698 284.723 439.603 277.189C438.37 272.757 436.235 269.372 433.197 267.034C430.119 264.548 425.567 263.347 419.543 263.431C413.625 263.327 405.717 264.651 395.819 267.404L383.854 270.732L376.704 245.028L388.892 241.638C398.641 238.926 405.781 235.985 410.311 232.815C414.947 229.457 417.72 225.98 418.63 222.385C419.646 218.601 419.579 214.64 418.429 210.504C416.868 204.89 413.883 201.026 409.474 198.909C405.173 196.605 398.96 196.582 390.835 198.842C385.812 200.239 381.417 202.177 377.651 204.657C373.843 206.99 370.487 209.515 367.583 212.233C364.826 214.909 362.418 217.409 360.358 219.733L338.437 201.002C341.752 196.897 345.592 192.964 349.957 189.204C354.47 185.402 359.644 181.973 365.478 178.918C371.313 175.863 378.071 173.267 385.753 171.13C402.003 166.61 415.779 166.36 427.083 170.377C438.493 174.207 445.862 182.104 449.19 194.07Z",
    fill: "#1E293B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M175.839 294.96H156.059V329H122.249V294.96H52.0995V270.81L124.089 164.78H156.059V268.05H175.839V294.96ZM122.249 240.22C122.249 237.613 122.249 234.547 122.249 231.02C122.403 227.34 122.556 223.737 122.709 220.21C122.863 216.53 123.016 213.31 123.169 210.55C123.323 207.637 123.476 205.643 123.629 204.57H122.709C121.329 207.637 119.873 210.627 118.339 213.54C116.806 216.453 114.966 219.443 112.819 222.51L82.6895 268.05H122.249V240.22Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M316.999 278.678C313.991 291.517 310.254 302.768 305.785 312.43C301.467 322.127 296.229 330.034 290.071 336.151C284.098 342.154 277.091 346.182 269.051 348.236C261.16 350.324 252.064 350.162 241.763 347.749C228.924 344.742 219.168 338.992 212.496 330.5C205.823 322.007 201.905 311.168 200.742 297.982C199.728 284.831 201.232 269.671 205.254 252.502C209.31 235.184 214.564 220.824 221.014 209.421C227.465 198.019 235.565 189.995 245.315 185.349C255.065 180.704 266.732 179.972 280.318 183.155C293.157 186.162 302.913 191.912 309.585 200.404C316.293 208.747 320.21 219.586 321.339 232.922C322.502 246.108 321.055 261.36 316.999 278.678ZM238.844 260.371C236.012 272.463 234.305 282.773 233.726 291.298C233.181 299.675 233.987 306.32 236.142 311.235C238.483 316.035 242.489 319.1 248.162 320.429C253.836 321.758 258.712 320.774 262.791 317.477C267.02 314.216 270.75 308.711 273.982 300.964C277.398 293.103 280.54 283.051 283.408 270.809C286.276 258.567 287.907 248.241 288.303 239.829C288.882 231.303 288.002 224.64 285.662 219.84C283.506 214.926 279.592 211.804 273.918 210.475C268.245 209.146 263.277 210.187 259.013 213.598C254.934 216.894 251.261 222.491 247.994 230.387C244.762 238.134 241.712 248.129 238.844 260.371Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M437.19 194.07C439.203 201.308 439.399 208.018 437.776 214.199C436.3 220.339 433.45 225.827 429.225 230.663C425.147 235.457 420.084 239.571 414.036 243.004L414.221 243.669C427.336 241.612 438.007 242.783 446.233 247.179C454.606 251.535 460.251 258.957 463.169 269.445C465.716 278.604 465.727 287.514 463.202 296.174C460.784 304.645 455.443 312.337 447.18 319.251C439.024 325.976 427.56 331.393 412.787 335.502C404.071 337.926 395.741 339.447 387.796 340.065C379.851 340.684 372.165 340.514 364.736 339.556L356.847 311.193C364.588 312.701 372.398 313.313 380.277 313.032C388.304 312.709 395.494 311.664 401.846 309.897C413.812 306.569 421.583 302.179 425.16 296.728C428.884 291.236 429.698 284.723 427.603 277.189C426.37 272.757 424.235 269.372 421.197 267.034C418.119 264.548 413.567 263.347 407.543 263.431C401.625 263.327 393.717 264.651 383.819 267.404L371.854 270.732L364.704 245.028L376.892 241.638C386.641 238.926 393.781 235.985 398.311 232.815C402.947 229.457 405.72 225.98 406.63 222.385C407.646 218.601 407.579 214.64 406.429 210.504C404.868 204.89 401.883 201.026 397.474 198.909C393.173 196.605 386.96 196.582 378.835 198.842C373.812 200.239 369.417 202.177 365.651 204.657C361.843 206.99 358.487 209.515 355.583 212.233C352.826 214.909 350.418 217.409 348.358 219.733L326.437 201.002C329.752 196.897 333.592 192.964 337.957 189.204C342.47 185.402 347.644 181.973 353.478 178.918C359.313 175.863 366.071 173.267 373.753 171.13C390.003 166.61 403.779 166.36 415.083 170.377C426.493 174.207 433.862 182.104 437.19 194.07Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2345_36774",
    x1: 99.47,
    y1: 76.0806,
    x2: 99.47,
    y2: 154.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7E9FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2345_36774",
    x1: 391.866,
    y1: 99.0317,
    x2: 391.866,
    y2: 178.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7E9FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2345_36774",
    x1: 37.9983,
    y1: 16.0825,
    x2: 90.316,
    y2: 16.0825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51ADC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#55AFC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#74BFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8FCDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#A5D89D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#B6E194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#C1E78E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C8EA8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAEB8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2345_36774",
    x1: 40.9069,
    y1: 10.036,
    x2: 32.4453,
    y2: 10.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AEBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#89E9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#84E2DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7DD7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#72C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#64B0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5395F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2345_36774",
    x1: 1857.57,
    y1: 797.103,
    x2: 1756.36,
    y2: 797.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#32CED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#36C6DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#3CB7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45A3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2345_36774",
    x1: 1713.35,
    y1: 749.603,
    x2: 1627.68,
    y2: 749.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AEBD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#89E9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#84E2DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#7DD7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#72C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#64B0EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5395F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5193FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2345_36774",
    x1: 76.8599,
    y1: 25.2072,
    x2: 91.5352,
    y2: 25.2072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7BE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F7BC83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F7B67B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F7AC6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F79E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2345_36774",
    x1: 163.525,
    y1: 36.4309,
    x2: 163.045,
    y2: 54.0906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B6ED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#796DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7268D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6760C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#5655BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2345_36774",
    x1: 19579.9,
    y1: 3483.79,
    x2: 19540.2,
    y2: 5264.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B6ED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#796DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7268D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6760C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#5655BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2345_36774",
    x1: 8696.28,
    y1: 1297.62,
    x2: 8691.63,
    y2: 1576.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B6ED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#796DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7268D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6760C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#5655BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2345_36774",
    x1: 26133.8,
    y1: 10490.4,
    x2: 40045.1,
    y2: 10490.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B6ED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#796DD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#7268D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6760C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#5655BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#4047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333EA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2345_36774",
    x1: 144.242,
    y1: 65.8935,
    x2: 199.707,
    y2: 65.8935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C0887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3F0987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#470E87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#561588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#6B1F89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822A8A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.18027bd4904117debb5ac911f9d7aeaa.svg";
export { ForwardRef as ReactComponent };